module.exports = __webpack_public_path__ + "img/start_bg.170ed3de.png";